<div class="card card--widget is-fullheight" *ngIf="countries">
  <div class="card-content">
    <div class="country-comparison">

      <div style="display: flex; align-items: center;">
        <i class="fab fa-ubuntu is-size-4 mb-2 mr-2"></i>

        <p class="country-comparison__title mb-2">
          Compare incentives
        </p>
      </div>

      <form [formGroup]="countryForm" class="country-comparison__form">

        <div class="country-comparison__type mb-0">
          <div class="family-radio-group">
            <label
              *ngFor="let family of families"
              class="family-radio"
            >
              <input
                type="radio"
                name="family"
                [value]="family.id"
                [checked]="selectedFamily === family.id"
                (change)="changeFamily(family.id)"
              />

              <span class="family-radio__label">
                {{ family.shortLabel }}
              </span>
            </label>
          </div>
        </div>

        <!-- Countries -->
        <div class="country-selects">

          <div class="select is-small is-fullwidth mr-2">
            <select formControlName="country1">
              <option
                *ngFor="let country of countries"
                [value]="country.label"
              >
                {{ country.label }}
              </option>
            </select>
          </div>

          <div class="select is-small is-fullwidth mr-2">
            <select formControlName="country2">
              <option
                *ngFor="let country of countries"
                [value]="country.label"
              >
                {{ country.label }}
              </option>
            </select>
          </div>

        </div>

        <!-- Button -->
        <a
          [routerLink]="['/incentives']"
          [queryParams]="{
            'f:Country': [
              countryForm.value.country1,
              countryForm.value.country2
            ],
            'dataset': this.selectedFamily
          }"
          class="button compare-button"
        >
          View results
        </a>

      </form>
    </div>
  </div>
</div>
